import { types } from 'mobx-state-tree';

import { validateEmail } from '../utils';

import { EMAIL_KEYS } from './consts';
import { actions } from './EditContactActions';

const model = {
  contactKeyBeingEdited: types.maybeNull(types.string),
  isManuallyAdded: types.optional(types.boolean, false),
  inputValue: types.optional(types.string, ''),
  originalValue: types.optional(types.string, ''),
  isBulk: types.optional(types.boolean, false),
};

const views = self => ({
  get hasInputValidationError() {
    if (EMAIL_KEYS.includes(self.contactKeyBeingEdited)) {
      if (self.isManuallyAdded && !self.inputValue) {
        return false;
      }

      return !validateEmail(self.inputValue);
    }

    return false;
  },
});

const EditContactModel = types
  .model(model)
  .actions(actions)
  .views(views);

export default EditContactModel;
